import { motion } from "framer-motion"

interface OnboardingWelcomeProps {
  onStart: () => void
  onSkip: () => void
}

export const OnboardingWelcome = ({ onStart, onSkip }: OnboardingWelcomeProps) => {
  return (
    <div className="absolute inset-0 z-[45] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onSkip} />
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.2, ease: [0.25, 1, 0.5, 1] }}
        className="relative bg-white/95 backdrop-blur-sm rounded-xl shadow-lg p-6 max-w-sm w-full mx-4 text-center"
      >
        <h2 className="text-lg font-bold text-gray-800 mb-2">Bienvenue dans l'Explorateur</h2>
        <p className="text-sm text-gray-500 mb-6">Découvrez les fonctionnalités clés en quelques étapes.</p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={onSkip}
            className="px-4 py-2 text-sm text-gray-500 hover:text-gray-700 transition-colors rounded-lg hover:bg-gray-100"
          >
            Passer
          </button>
          <button
            onClick={onStart}
            className="px-5 py-2 text-sm font-medium text-white rounded-lg transition-colors"
            style={{ backgroundColor: "#1E40AF" }}
          >
            C'est parti !
          </button>
        </div>
      </motion.div>
    </div>
  )
}
